export const init = () => {
  const getAllPickerEl = document.querySelectorAll(".js-component-options");

  if (getAllPickerEl.length === 0) return;

  getAllPickerEl.forEach((cur) => {

    const mainComponent = cur.nextElementSibling;

    if (!mainComponent) return;

    const mainComponentContainer = mainComponent.querySelector(".container");

    const componentData = [
      { label: "Barva vnějšího pozadí", data: cur.dataset.background?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva karet", data: cur.dataset.insidebackground?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva hlavní karty", data: cur.dataset.mainCardBackground?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Zarovnání obsahu na výšku", data: cur.dataset.verticalAlignment?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Zarovnání obsahu karty na výšku", data: cur.dataset.cardVerticalAlignment?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Zarovnání textu", data: cur.dataset.textAlignment?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva textu", data: cur.dataset.textColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva nadpisu", data: cur.dataset.titleColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Velikost nadpisu", data: cur.dataset.titleSize?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva tlačítka", data: cur.dataset.buttonColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Kulaté rohy tlačítka", data: cur.dataset.buttonStyleRoundedCorners?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Kulaté rohy", data: cur.dataset.roundedCorners?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Kulaté rohy karet", data: cur.dataset.cardRoundedCorners?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Velikost nadpisu karet", data: cur.dataset.cardTitleSize?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva nadpisu karet", data: cur.dataset.cardTitleColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva textu karet", data: cur.dataset.cardTextColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva tlačítka karet", data: cur.dataset.cardButtonColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Zarovnání textu karet", data: cur.dataset.cardTextAlignment?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Kulaté rohy tlačítka karet", data: cur.dataset.cardButtonStyleRoundedCorners?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva tlačítka 2", data: cur.dataset.buttonColor2?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Pořadí mobilního obrázku", data: cur.dataset.mobilePicturePosition?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Velikost nadpisu hlavní karty", data: cur.dataset.mainCardTitleSize?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva nadpisu hlavní karty", data: cur.dataset.mainCardTitleColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva textu hlavní karty", data: cur.dataset.mainCardTextColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Barva tlačítka hlavní karty", data: cur.dataset.mainCardButtonColor?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Zarovnání textu hlavní karty", data: cur.dataset.mainCardTextAlignment?.split(",") || [], classTarget: mainComponentContainer },
      { label: "Kulaté rohy tlačítka hlavní karty", data: cur.dataset.mainCardButtonStyleRoundedCorners?.split(",") || [], classTarget: mainComponentContainer }
    ];

    const containerDiv = document.createElement("div");
    containerDiv.classList.add("container");

    const activeClasses = {};

    componentData.forEach(({ label, data, classTarget }) => {
      if (data.length > 0 && classTarget) {
        const inputGroupDiv = document.createElement("div");
        inputGroupDiv.classList.add("input-group");

        const labelElement = document.createElement("label");
        labelElement.textContent = label;

        const selectElement = document.createElement("select");

        selectElement.innerHTML = `<option value="" disabled selected>Vyberte ${label.toLowerCase()}</option>` +
          data.map(item => `<option value="${item}">${item}</option>`).join('');

        const defaultClass = data[0];

        if (defaultClass) {
          classTarget.classList.add(defaultClass);
          activeClasses[label] = defaultClass;
          selectElement.value = defaultClass;
        }

        selectElement.addEventListener("change", (event) => {
          const newClass = event.target.value;

          if (activeClasses[label]) {
            classTarget.classList.remove(activeClasses[label]);
          }

          classTarget.classList.add(newClass);
          activeClasses[label] = newClass;
        });

        inputGroupDiv.appendChild(labelElement);
        inputGroupDiv.appendChild(selectElement);
        containerDiv.appendChild(inputGroupDiv);
      }
    });

    cur.prepend(containerDiv);
  });
};
